import { Checkbox } from "@chakra-ui/react";
import { Card, FormRow, InputDatePicker, Select } from "@components/ui-kit";
import { t } from "@lingui/macro";
import {
  fieldToCheckboxProps,
  fieldToSelectProps,
} from "@src/utils/forms/inputHelpers";
import { observer } from "mobx-react-lite";
import React from "react";
import { useScrollToWhen } from "../../hooks";
import { useStore } from "../../store";

export const PaymentInfo = observer(function PaymentInfo() {
  const store = useStore();
  const { form } = store;

  const formRowRef = useScrollToWhen(
    store.scrollTo.expenseDataCard_paymentInfo,
  );

  return (
    <Card.Section>
      <FormRow title={t`Already paid`} ref={formRowRef}>
        <Checkbox
          {...fieldToCheckboxProps(form.already_paid)}
          isDisabled={store.arePaymentMethodInputsDisabled}
        />
      </FormRow>
      {form.already_paid.value && (
        <React.Fragment>
          <FormRow title={t`Payment method`}>
            <Select
              isDisabled={store.arePaymentMethodInputsDisabled}
              placeholder={t`Select payment method`}
              {...fieldToSelectProps(
                form.payment_type_id,
                store.paymentTypeOptions,
              )}
            />
          </FormRow>
          <FormRow title={t`Payment date`}>
            <InputDatePicker
              isDisabled={store.arePaymentMethodInputsDisabled}
              selected={form.paid_at.$}
              onChange={(val) => {
                form.paid_at.onChange(val?.start);
              }}
              error={form.paid_at.error}
            />
          </FormRow>
        </React.Fragment>
      )}
    </Card.Section>
  );
});
